import React from 'react';
import { Col, Input, Form, Space, Tooltip } from '../../../../components';
import { passwordRequirementText } from './index';
import { InfoCircleTwoTone } from '@ant-design/icons';

export const PasswordFields = React.memo(() => (
    <>
        <Col span={24}>
            <Form.Item
                label={'Current Password'}
                name="current_password"
                dependencies={['new_password', 'confirm_password']}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const newPass = getFieldValue('new_password');
                            const confirmPass = getFieldValue('confirm_password');
                            if ((newPass || confirmPass) && !value) {
                                return Promise.reject('Current password is required.');
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Input.Password size="large" />
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item
                label={
                    <Space>
                        New Password{' '}
                        <Tooltip title={passwordRequirementText}>
                            <InfoCircleTwoTone />
                        </Tooltip>
                    </Space>
                }
                name="new_password"
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const cur = getFieldValue('current_password');
                            if (cur || value || getFieldValue('confirm_password')) {
                                if (!value) {
                                    return Promise.reject('New password is required.');
                                }
                                if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/.test(value)) {
                                    return Promise.reject(passwordRequirementText);
                                }
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Input.Password size="large" />
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item
                label="Confirm Password"
                name="confirm_password"
                dependencies={['new_password']}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const newPass = getFieldValue('new_password');
                            if ((newPass || value || getFieldValue('current_password')) && value !== newPass) {
                                return Promise.reject('Passwords do not match.');
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Input.Password size="large" />
            </Form.Item>
        </Col>
    </>
));
